export default __webpack_public_path__ + "static/media/search-home1.c6ad5890.png";